import styles from '@copilot/common/pages/campaignDashboard/summaryV2/campaignPerformance/campaignPerformance.module.less';
import LoadingIndicator from '@copilot/common/components/loadingIndicator/spinner';
import { Skeleton } from 'antd';

/**
 * Loader for a single percentage ring with description
 */
export function StatsLoader() {
    return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingRingContainer}>
                <LoadingIndicator isLoading className={styles.loadingIndicator} />
            </div>
            <div className={styles.loadingTextPlaceholder}>
                <Skeleton.Input active size="small" className={styles.loadingMetricName} />
            </div>
        </div>
    );
}
